// AUTO-GENERATED FILE. Do not edit.
import { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import { PokeType } from "types/pokemon/poke-type";

export const pikachu: PokeData = {
  "id": 25,
  "name": "pikachu",
  "height": 4,
  "weight": 60,
  "base_experience": 112,
  "types": [
    PokeType.ELECTRIC
  ],
  "api_moves": [
    "slam",
    "double-kick",
    "tail-whip",
    "growl",
    "thunder-shock",
    "thunderbolt",
    "thunder-wave",
    "thunder",
    "agility",
    "quick-attack",
    "double-team",
    "light-screen",
    "swift",
    "sweet-kiss",
    "charm",
    "spark",
    "iron-tail",
    "feint",
    "nasty-plot",
    "discharge",
    "electro-ball",
    "wild-charge",
    "play-nice",
    "nuzzle"
  ],
  "moves": [
    "double-kick",
    "growl",
    "thunder-shock",
    "thunderbolt",
    "thunder",
    "quick-attack",
    "sweet-kiss",
    "wild-charge",
    "electric-wrath",
    "quick-tempo",
    "volt-crash",
    "thunder-fang",
    "electric-terrain"
  ],
  "evolution_chain": {
    "id": 10,
    "item": null,
    "species": [
      {
        "name": "pichu",
        "order": 25,
        "types": [
          PokeType.ELECTRIC
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "pikachu",
        "order": 26,
        "types": [
          PokeType.ELECTRIC
        ],
        "evolves_from_species_id": 172,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": null,
            "location": null,
            "min_happiness": 220,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "raichu",
        "order": 27,
        "types": [
          PokeType.ELECTRIC
        ],
        "evolves_from_species_id": 25,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": {
              "name": "thunder-stone"
            },
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.USE_ITEM
            },
            "gender": null
          }
        ]
      },
      {
        "name": "raichu-alola",
        "order": 27,
        "types": [
          PokeType.ELECTRIC
        ],
        "evolves_from_species_id": 25,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": {
              "name": "thunder-stone"
            },
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.USE_ITEM
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 40,
    "speed": 90,
    "ability_power": 55
  },
  "stat_changes": [],
  "catch_rate": 190,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
